import { FC, useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styled from 'styled-components';
import ActionCell from 'components/actions/ActionCell';
import { useTranslation } from 'react-i18next';
import { IStepFive } from '../types';

interface IProps {
  data: IStepFive;
  methods: any;
  hasPermission: boolean;
}

const Actions: FC<IProps> = ({ data, methods, hasPermission }) => {
  const { t } = useTranslation();
  const {
    approve: approveDefaults,
    sign: signDefaults,
    approve_options: approveOptions,
    sign_options: signOptions,
  } = data;

  const [approve, setApprove] = useState(approveDefaults);
  const [sign, setSign] = useState(signDefaults);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setApprove(approveDefaults);
    setSign(signDefaults);
  }, [data]);

  const maxApprovePositionsAvailable: number = approveOptions.reduce((optionCount, group) => {
    const optionsLength = group?.options?.length || 0;
    return optionCount + optionsLength;
  }, 0);

  const maxSignPositionsAvailable: number = signOptions.reduce((optionCount, group) => {
    const optionsLength = group?.options?.length || 0;
    return optionCount + optionsLength;
  }, 0);
  return (
    <Row className="mt-5 mb-5">
      <Col sm={6}>
        <h3 className="h5">{t('docWizard.step5.approveAndSignLevels')}</h3>
      </Col>
      <Col
        sm={12}
        style={{ maxWidth: isMobile ? '100%' : '50%' }}
      >
        <ResponsiveRow className="d-block pr-3">
          <div className="d-flex custom-flex-column">
            <ActionCellContainer className="pl-3 pr-2">
              <ActionCell
                title={t('documents.approvals')}
                name="default-approve"
                options={approveOptions}
                maxPositionsAvailable={maxApprovePositionsAvailable}
                selected={approve}
                methods={methods}
                updateData={actionData => {
                  setApprove(actionData);
                }}
                hasPermission={hasPermission}
              />
            </ActionCellContainer>
            <ActionCellContainer className="pl-3 pr-2">
              <ActionCell
                title={t('documents.signatures')}
                name="default-sign"
                options={signOptions}
                maxPositionsAvailable={maxSignPositionsAvailable}
                selected={sign}
                methods={methods}
                updateData={actionData => {
                  setSign(actionData);
                }}
                hasPermission={hasPermission}
              />
            </ActionCellContainer>
          </div>
        </ResponsiveRow>
      </Col>
    </Row>
  );
};

export default Actions;

const ResponsiveRow = styled(Row)`
  @media ${props => props.theme.breakpoints.sm} {
    .custom-flex-column {
      flex-direction: column;
    }
  }
`;

const ActionCellContainer = styled.div`
  flex: 1;

  @media ${props => props.theme.breakpoints.sm} {
    &:not(:last-child) {
      padding-bottom: 1rem; /* Adds spacing between the items when they're in column layout */
    }
  }
`;
